export enum PerformanceImpactRatio {
  PERFORMANCE_2 = 'performance_2',
  PERFORMANCE_1 = 'performance_1',
  BOTH = 'both',
  IMPACT_1 = 'impact_1',
  IMPACT_2 = 'impact_2',
}
